import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { createStyles, makeStyles } from 'transfix-ui/core'
import { Button, Tab } from 'transfix-ui'
import { useBidsApi } from '../hooks/useBidsApi'
import { useFMSAnalytics } from '../hooks/useFMSAnalytics/useFMSAnalytics'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      /**
       * This is to remove the bullet point from the <li> component which the Tab component uses
       */
      listStyleType: 'none',
    },
  })
)

interface IMyBidsButtonProps {}

export const MyBidsButton: FC<IMyBidsButtonProps> = () => {
  const { trackEvent } = useFMSAnalytics()
  const classes = useStyles()
  const history = useHistory()

  const { acceptedBids } = useBidsApi()
  const onClickHandler = () => {
    trackEvent('Bids Page', 'CLICKED_MY_BIDS_BUTTON')
    history.push('/bids')
  }

  const count = acceptedBids.length

  return (
    <div className={classes.root}>
      <Button color='tertiary' onClick={onClickHandler}>
        <Tab active label='My Bids' count={count}>
          <div />
        </Tab>
      </Button>
    </div>
  )
}
